/* One line in the header, like the part menu trigger */
.group {
  flex-shrink: 0;
  white-space: nowrap;
}

/* Touch targets of at least 44px in Perform */
.option {
  min-height: var(--tuna-spacing-6);
  text-transform: none;
}
